import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-fabricator-rewards',
  templateUrl: './fabricator-rewards.component.html',
  styleUrl: './fabricator-rewards.component.scss',
})
export class FabricatorRewardsComponent {
  comentario: string = '';
  valoracion: number = 0;
  
  telefono: string = this.getTranslatedLabel('rewards.contact_telf');
  email: string = this.getTranslatedLabel('rewards.contact_mail');

  constructor(private translateService: TranslateService ) {}

  getTranslatedLabel(key: string): string {
    return this.translateService.instant(key);
  }

}
